// This ensures our page is statically rendered
export const prerender = true
